import * as AnalyticsConstants from '../constants';
import * as D from '../deps';

const logger = D.Logger.child({ component: 'Analytics/helpers.js' });

function getActionFromDomain(requestedString) {
  const str = `analytics.actions.${requestedString}`;
  return D.getInDomain(str, () => logger.warn(`getActionFromDomain(): "${str}" does not exist.`));
}

export const eventLoggingMap = {
  [AnalyticsConstants.EventTypes.CLICK]: {
    [AnalyticsConstants.EventNames.CLICKED_SIGN_UP]: ['_gtm_.signUpClicked'],
    [AnalyticsConstants.EventNames.CLICKED_APP_STORE_LINK]: ['_gtm_.appStoreLinkClicked'],
    [AnalyticsConstants.EventNames.CLICKED_VIEW_PLANS]: ['_gtm_.viewPlansClicked'],
    [AnalyticsConstants.EventNames.CLICKED_UPGRADE_CTA]: ['_gtm_.upgradeCtaClicked'],
    [AnalyticsConstants.EventNames.CLICKED_UPGRADE_DISCOUNT_PLAN_LINK]: [
      '_gtm_.upgradeDiscountPlanLinkClicked',
    ],
  },
};

export function getLoggingActions(eventType, eventName) {
  return (eventLoggingMap[eventType][eventName] || []).map(getActionFromDomain);
}
